import { Link } from 'react-router-dom';

export default function PortalFooter() {
    return (
        <footer className="mt-auto border-t border-slate-200 bg-slate-900 text-slate-300">
            <div className="mx-auto max-w-6xl px-4 py-10 sm:py-12">
                <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-wide text-amber-400/90">Zehuma QR Menü</p>
                        <p className="mt-2 text-sm leading-relaxed text-slate-400">
                            Restoran ve işletmeler için modern dijital menü deneyimi.
                        </p>
                    </div>
                    <div>
                        <p className="text-sm font-semibold text-white">Zehuma Bilgi Teknolojileri A.Ş.</p>
                        <p className="mt-2 text-sm text-slate-400">İletişim bilgileri</p>
                        <ul className="mt-3 space-y-2 text-sm">
                            <li>
                                <span className="text-slate-500">Telefon</span>
                                <br />
                                <a href="tel:08503023545" className="text-amber-400 hover:underline">
                                    0850 302 35 45
                                </a>
                            </li>
                            <li>
                                <span className="text-slate-500">E-posta</span>
                                <br />
                                <a href="mailto:hello@zehuma.com" className="text-amber-400 hover:underline">
                                    hello@zehuma.com
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-sm font-semibold text-white">Adres</p>
                        <p className="mt-2 text-sm leading-relaxed text-slate-400">
                            75. Yıl Mah. 5391 Sk. No: 64 D: 3
                            <br />
                            Yunusemre / Manisa
                        </p>
                        <p className="mt-4 text-sm font-semibold text-white">Çalışma saatleri</p>
                        <p className="mt-1 text-sm text-slate-400">
                            Pazartesi - Cuma: 09:00 - 18:00
                            <br />
                            7/24 Teknik Destek
                        </p>
                        <Link
                            to="/iletisim"
                            className="mt-4 inline-block text-sm font-medium text-amber-400 hover:underline"
                        >
                            İletişim sayfası →
                        </Link>
                    </div>
                </div>
                <div className="mt-10 border-t border-slate-700 pt-6 text-center text-xs text-slate-500">
                    © {new Date().getFullYear()} Zehuma Bilgi Teknolojileri A.Ş. Tüm hakları saklıdır.
                </div>
            </div>
        </footer>
    );
}
